import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";

// v1.37.0 Süper Yönetici: rezerve + atanmamış çifti serbest bırak (varsayılan: numara yeniden verilmez)
export default function ReleasePairDialog({ batch, pair, onClose, onDone }) {
  const [reason, setReason] = useState("");
  const [reuse, setReuse] = useState(false);
  const [warn, setWarn] = useState(null);
  const [busy, setBusy] = useState(false);
  const go = async (ackExported = false) => {
    if (reuse && !window.confirm(`${pair.code} / ${pair.gtin} yeniden kullanılabilir yapılacak. Bu barkodun hiç basılmadığını/kullanılmadığını İKİNCİ KEZ onaylıyor musunuz?`)) return;
    setBusy(true);
    try {
      await api.post(`/identifiers/batches/${batch.id}/release`, { code: pair.code, reason, reusable: reuse, confirm_reusable: reuse, acknowledge_exported: ackExported });
      toast.success(reuse ? "Çift serbest bırakıldı (yeniden kullanılabilir)" : "Çift serbest bırakıldı (numara tekrar verilmez)"); onDone();
    } catch (e) {
      if (e.response?.data?.detail?.code === "exported_warning") setWarn(e.response.data.detail.message); else toast.error(apiError(e));
    }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="release-pair-dialog">
        <DialogHeader><DialogTitle>Rezerve Kodu Serbest Bırak · <span className="font-mono">{pair.code} / {pair.gtin}</span></DialogTitle></DialogHeader>
        <div className="space-y-3 text-sm">
          <p className="text-slate-600">Varsayılan: çift <b>serbest_birakildi</b> olur ve bu numaralar bir daha verilmez (barkod basılmış olabilir). Geçmiş görünür kalır.</p>
          <Input placeholder="Gerekçe (zorunlu)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="release-reason" />
          <label className="flex items-start gap-2 rounded border border-rose-200 bg-rose-50 p-2 text-[12px] text-rose-800">
            <input type="checkbox" checked={reuse} onChange={(e) => { setReuse(e.target.checked); setWarn(null); }} data-testid="release-reusable" />
            Numarayı yeniden kullanılabilir yap — bu barkod hiç basılmadı/kullanılmadı, onaylıyorum</label>
          {batch.downloads > 0 && reuse && !warn && <div className="text-[12px] font-semibold text-rose-700" data-testid="release-exported-hint">Bu parti {batch.downloads} kez Excel olarak indirildi.</div>}
          {warn && <div className="rounded border-2 border-rose-500 bg-rose-50 p-2 text-[12px] font-semibold text-rose-800" data-testid="release-exported-warning">{warn}</div>}
        </div>
        <DialogFooter>
          {warn ? <Button variant="destructive" disabled={busy} onClick={() => go(true)} data-testid="release-confirm-exported">Riski anladım, yine de serbest bırak</Button>
            : <Button variant="destructive" disabled={busy || reason.trim().length < 5} onClick={() => go(false)} data-testid="release-submit">Serbest Bırak</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
